module.exports = __webpack_public_path__ + "media/images/icons/arrow_grey_down-d1506e8077277de8c6d81eaa0ad60741.svg";